import type { CollectionTile } from "../types/product";

export const collections: CollectionTile[] = [
  {
    id: "verlichting",
    title: "Verlichting",
    description: "Organische tafellampen en sfeerlampen met warm, gelaagd licht.",
    count: 31,
    image:
      "https://cdn.shopify.com/s/files/1/0961/2060/2951/collections/1000055109.jpg?v=1780495365",
    filter: "Verlichting",
  },
  {
    id: "woondecoratie",
    title: "Woondecoratie",
    description: "Vazen, objecten en wanddecoratie.",
    count: 70,
    image:
      "https://cdn.shopify.com/s/files/1/0961/2060/2951/collections/woondecoratie.jpg?v=1779970937",
    filter: "Woondecoratie",
  },
  {
    id: "gepersonaliseerd",
    title: "Gepersonaliseerd",
    description: "Met naam, tekst of eigen foto.",
    count: 14,
    image:
      "https://cdn.shopify.com/s/files/1/0961/2060/2951/collections/gepersonaliseerd_17e04dee-6616-4bea-aab5-2de40b3ce626.jpg?v=1779971002",
    filter: "Gepersonaliseerd",
  },
  {
    id: "cadeautips",
    title: "Cadeautips",
    description: "Originele cadeaus die net even anders zijn.",
    count: 71,
    image:
      "https://cdn.shopify.com/s/files/1/0961/2060/2951/collections/1000055131.jpg?v=1780495585",
    filter: "Alles",
  },
];
